import { render, staticRenderFns } from "./PriceNormal.vue?vue&type=template&id=d97fd2d6&scoped=true&"
import script from "./PriceNormal.vue?vue&type=script&lang=js&"
export * from "./PriceNormal.vue?vue&type=script&lang=js&"
import style0 from "./PriceNormal.vue?vue&type=style&index=0&id=d97fd2d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97fd2d6",
  null
  
)

export default component.exports